module.exports = __webpack_public_path__ + "static/media/Stoutland_gaussian2.2845a5b0.png";